<template>
    <div id="myOrderList">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    @load="onLoad"
  >
        <van-panel v-for="(value,index) in list" :key="index">
            <template #header>
                <div class="van-cell van-panel__header">
                    <div class="van-cell__title" style="width:70%;flex:none;">
                        <span
                            class="van-cell__title_lable"
                            @click.capture="$router.push('/bfMerchantsShop?businessNumber='+value.businessNumber+'&&businessProperty='+value.businessDetailsVo.businessProperties)"
                        >
                            <span
                                class="van-cell__title_icon"
                                :class="businessPropertyTypeColor[value.businessDetailsVo.businessProperties-1]"
                            >
                                {{businessPropertyType[value.businessDetailsVo.businessProperties-1]}}
                            </span>&nbsp;{{value.businessName}}&nbsp;<van-icon name="arrow" />
                        </span>
                        <div class="van-cell__label">{{value.orderTime}}</div>
                    </div>
                    <div class="van-cell__value van-panel__header-value" style="width:30%;flex:none;">
                        <span class="panelState">{{statusFilter(value.orderStatus)}}</span>
                    </div>
                </div>
            </template>
            <template #default>
                <div class="panelContent" @click="$router.push('/orderDetail/'+value.orderId)">
                    <div class="panelContentLeft">
                        <van-image :src="baseUrl.imgUrl+item" v-for="(item,key) in (value.productImages==null?[]:value.productImages.split(','))" :key="key"/>
                    </div>
                    <div class="panelContentRight">
                        <p>共{{value.productNum}}件</p>
                        <p style="color:#E85B4D">￥{{value.orderMoney}}{{value.jfdkNum?("+"+value.jfdkNum+"积分"):''}}</p>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="panelContentFooter">
                    <van-button v-if="(value.orderStatus==15||value.orderStatus==5||value.orderStatus==6||value.orderStatus==7)&&value.businessDetailsVo.businessProperties==2" size="small" @click="$router.push('/deliveryDetails?orderNumber='+value.orderId)">查看物流</van-button>
                    <van-button v-if="value.orderStatus==9" size="small" @click="deleteOrderFn({orderNumber:value.orderId},index)">删除订单</van-button>
                    <van-button v-if="value.orderStatus==1" size="small" @click="cancelOrderFn(value.orderId,index)">取消订单</van-button>
                    <van-button v-if="(value.orderStatus==15&&value.businessDetailsVo.businessProperties==2)||value.orderStatus==4" size="small" type="danger" @click="confirmOrderFn(value.orderId,index)">确认收货</van-button>
                    <van-button v-if="value.orderStatus==1" size="small" type="info" @click="confirmPay(value,index)">立即付款</van-button>
                    <van-button v-if="value.orderStatus==5" size="small" type="primary" @click="$router.push('/comment?orderNumber='+value.orderId)">评价</van-button>
                </div>
            </template>
        </van-panel>
  </van-list>
</van-pull-refresh>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import baseUrl from '@/config/baseUrl';
import { Dialog } from 'vant';
export default {
    name: 'MyOrderList',
    props:{
        type:{
            type:Number,
            default:1
        }
    },
    data() {
        return {
            loading: false,
            finished: false,
            list: [],
            refreshing: false,
            page:1,
            rows:10,
            businessPropertyType:['平台自营','缤纷','自营','周边'],
            businessPropertyTypeColor:['van-cell__title_iconB','van-cell__title_iconR','van-cell__title_iconB','van-cell__title_iconO'],
            baseUrl
        };
    },
    computed: {
        ...mapState('myOrder', {
            myOrderList: 'myOrderList'
        }),
        orderStatus() {
            return this.$store.state.orderStatus;
        }
    },
    methods: {
        ...mapActions('myOrder', {
            getMyOrderList: 'getMyOrderListAction'
        }),
        ...mapActions('myOrder', {
            cancelOrder: 'cancelOrderAction'
        }),
        ...mapActions('myOrder', {
            deleteOrder: 'deleteOrderAction'
        }),
        ...mapActions('myOrder', {
            confirmOrder: 'confirmOrderAction'
        }),
        onLoad() {
            if (this.refreshing) {
                this.list = [];
                this.page = 1;
                this.refreshing = false;
            }
            this.getMyOrderList({
                orderType:this.type,
                page:this.page++,
                rows:this.rows
            }).then((res) => {
                for (let i = 0; i < res.length; i++) {
                    this.list.push(res[i]);
                }
                this.loading = false;
                if (res.length < 10) {
                    this.finished = true;
                }
            });
        },
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        confirmPay(value,index) {
            this.$commonPay({
                data: {
                    xmBh:value.businessNumber+','+value.businessDetailsVo.businessCompanyBonus+','+value.businessDetailsVo.businessPlatformBonus+','+value.businessDetailsVo.businessProperties+','+value.deliverMethods+','+value.businessDetailsVo.payRate+','+value.sendMoney,
                    tradeNo:value.orderId,
                    totalFee:value.orderFactMoney,
                    orderDesc:'欣商城',
                    gsbh:value.userCompany
                },
                successFn: () => {
                    this.getMyOrderList({orderNumber:value.orderId,orderType:3}).then((res_) => {
                        for(let key in this.list[index]) {
                            this.list[index][key] = res_[0][key]?res_[0][key]:'';
                        }
                    }).catch((res_) => {
                        this.$toast('订单状态刷新失败');
                    });
                }
            });
        },
        statusFilter(value) {
            if(!value) {
                return '';
            }
            let data = this.orderStatus.find(item=>{
                return item.key === String(value);
            });
            return data.value || '';
        },
        cancelOrderFn(params,index){
            Dialog.confirm({
                title: '提示',
                message: '此操作将取消该订单, 是否继续?'
            }).then(() => {
                this.cancelOrder(params).then((res) => {
                    this.$toast(res.msg);
                    this.getMyOrderList({orderNumber:params,orderType:3}).then((res_) => {
                        for(let key in this.list[index]) {
                            this.list[index][key] = res_[0][key]?res_[0][key]:'';
                        }
                    }).catch((res_) => {
                        this.$toast('订单状态刷新失败');
                    });
                }).catch((res) => {
                    this.$toast(res.error);
                });
            }).catch(() => {
            });
        },
        confirmOrderFn(params,index){
            Dialog.confirm({
                title: '提示',
                message: '此操作将确认收货, 是否继续?'
            }).then(() => {
                this.confirmOrder(params).then((res) => {
                    this.$toast(res.msg);
                    this.getMyOrderList({orderNumber:params,orderType:3}).then((res_) => {
                        for(let key in this.list[index]) {
                            this.list[index][key] = res_[0][key]?res_[0][key]:'';
                        }
                    }).catch((res_) => {
                        this.$toast('订单状态刷新失败');
                    });
                }).catch((res) => {
                    this.$toast(res.error);
                });
            }).catch(() => {
            });
        },
        deleteOrderFn(params,index){
            Dialog.confirm({
                title: '提示',
                message: '此操作将删除该订单, 是否继续?'
            }).then(() => {
                this.deleteOrder(params).then((res) => {
                    this.$toast(res.msg);
                    this.list.splice(index,1);
                }).catch((res) => {
                    this.$toast(res.error);
                });
            }).catch(() => {
            });
        }
    },
    created() {

    }
};
</script>
<style lang="scss">
    #myOrderList{
        .van-panel{
            margin: 10px;
            border-radius:5px;
            .van-cell{
                background: bottom;
            }
            .panelContent{
                height: 42px;
                overflow: hidden;
                padding: 15px;
                .panelContentLeft{
                    width: 70%;
                    display: inline-block;
                    text-align: left;
                    img{
                        width: 40px;
                        height: 40px;
                        margin-right: 10px;
                    }
                }
                .panelContentRight{
                    display: inline-block;
                    text-align: right;
                    width: 30%;
                    font-size:14px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(153,153,153,1);
                    line-height:20px;
                }
            }
            .van-panel__header{
                .van-cell__title{
                    text-align: left;
                    .van-cell__title_lable{
                        font-size:15px;
                        font-family:PingFang SC;
                        font-weight:bold;
                        color:rgba(51,51,51,1);
                        .van-icon{
                            display: inline-block;
                            color: #9C9C9C;
                            vertical-align: middle;
                        }
                    }
                    .van-cell__label{
                        font-size:12px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(102,102,102,1);
                    }
                    .van-cell__title_icon{
                        display: inline-block;
                        text-align: center;
                        width:39px;
                        border-radius:16px;
                        font-size:12px;
                        font-family:PingFang SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        line-height: 16px;
                    }
                    .van-cell__title_iconB{
                        background:#4BA4FB;
                    }
                    .van-cell__title_iconO{
                        background:#ED863F;
                    }
                    .van-cell__title_iconR{
                        background:#EB604E;
                    }
                }
                .panelState{
                    font-size:15px;
                    font-family:PingFang SC;
                    font-weight:500;
                    color:rgba(51,51,51,1);
                }
            }
            .panelContentFooter {
                text-align: right;

                button {
                    margin-left: 10px;
                }
            }
        }
    }
</style>
